import Base from '../../base';

export default class Default extends Base {
  init() {
    if(this.d.template.indexOf('index') == -1) return;

    this.bus.$on('index/scrollDown', (d) => {this.scrollDown();});
    this.bus.$on('vue/loaded', (d) => {this.newsletter();});
    this.bus.$on('vue/loaded', (d) => {this.onResize();});
    this.bus.$on('window/resize', (d) => {this.onResize();});
    this.bus.$on('window/scroll', (d) => {this.onScroll();});
  }

  onResize() {
    //Get distance of shop title from top
    var $title = $(this.b.vm.$refs.shop_title);

    if($title.is('*')) this.s.index.shop_title_top = $title.offset().top;

  }

  onScroll() {
    var offset = 200;
    var title_top  = this.s.index.shop_title_top;
    var scroll_top = this.s.window.scroll.top.current;
    //Compare shop title top to current scroll
    if(this.s.index.shop_title_top > -1) {
      this.s.index.shop_title_active = (scroll_top + offset < title_top);      
    }
  }

  scrollDown() {
    var top = this.s.window.resize.height.current;

    $('html').velocity('scroll', { duration: 750, offset: top });
  }

  newsletter() {
    var logged_in = this.d.logged_in;
    var hide_time = (this.ls.hide_newsletter == 'undefined') ? false : new Date(this.ls.hide_newsletter); 

    //Don't show if logged in
    if(logged_in) return;

    //Don't show if shown in last two weeks
    if(hide_time) {
      var current_time = new Date();
      var days         = 1000 * 60 * 60 * 24;
      var time_ago     = Math.round((current_time - hide_time)/days);

      if(time_ago < 14) return;
    }

    setTimeout(() => {
      this.s.overlay.current = 'newsletter';
    }, 15000);
  }
}